import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import Header from "../components/header/clientHeader";
import { Buffer } from "buffer";
import { Oval } from "react-loader-spinner";
import ProfileDetails from "../components/profileDetails/profileDetails";
import MiniProfileDetails from "../components/profileDetails/miniProfileDetail";
import Profile from "../components/profile/profileInClient";
import Login from "../components/loginModal/LoginModal";
import PublicLogin from "../components/loginModal/publicLogin";
import Snackbar from "@mui/material/Snackbar";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Popover } from '@typeform/embed-react'

import moment from "moment";
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import the styles

import "@react-pdf-viewer/core/lib/styles/index.css";

// Import form
import { useForm } from "react-hook-form";

// Import supabase configuration
import supabase from "../config/supabase";
import { hotjar } from 'react-hotjar';
import mixpanel from 'mixpanel-browser';

import {
  getClientNotification,
  getClient,
  getPublicClient,
  getClientProfilesDetails,
} from "../redux/actions/actions";

function Client() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

	const { client_Profiles, client ,publicClient, detailed_client_Profiles} = useSelector((state) => state.client);

  const [profiles, setProfiles] = useState([]);
  const [currentClient, setClient] = useState({});
  const [clientProfiles, setClientProfiles] = useState([]);
  const [boardId, setBoardId] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [profileId, setProfileId] = useState("");
  const [scheduledProfile, setScheduledProfile] = useState("");
  const [statusValue, setValue] = useState("New");
  const [showNotification, setShowNotification] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showNewModal, setshowNewModal] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [dateTime, setDateTime] = useState([]);
  const [dateButton, setDateButton] = useState(false);
  const [justView, setJustView] = useState(true);
  const [isPublic, setIsPublic] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [userToken, setUserToken] = useState("");
  const [tokenWithouturl, setTokenWithouturl] = useState("");
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState([]);
  const [clientView, setClientView] = useState(false);
  const [url, setUrl] = useState("/avatar.png");
  const [showProfileDetail, setShowProfileDetail] = useState(false);
  const [hideProfile, setHideProfile] = useState(false);
  const [applyTransition, setApplyTransition] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [clientInvitationId, setClientInvitationId] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [reqestInterview, setRequestInterview] = useState(false);
  const [toLogin, setToLogin] = useState(false);
  // const [onReturnFromCalendly, setOnReturnFromCalendly] = useState(false);
  // data time picker
  const [dateTimePicker, setDateTimePicker] = useState("");
  const [showLogin, setShowLogin] = useState(true);
  const [sessionDetails, setSessionDetails] = useState([]);
  const [miniScreenProfieDetail, setMiniScreenProfileDetail] = useState(false);

  //This hook using for form-validation
  const { handleSubmit } = useForm();

  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    borderRadius: "5px",
    padding: "20px",
    '@media (max-width: 800px)': {
      width: '90%',
      padding: '10px'
    },
  };

  const pageRefConf = (event) => {
    localStorage.removeItem("loggedIn");
  };

  const reportWindowSize = (e) => {
    var screenSize = window.screen.width;
    if(screenSize < 780) {
      if(showProfileDetail){
        setMiniScreenProfileDetail(true);
      }
    } else {
      setMiniScreenProfileDetail(false);
    }
  }
  
  useEffect( async() => {
    mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 

    // Testing Token
    // hotjar.initialize(2875931, 6);
    // Live Testing
    hotjar.initialize(2908411, 6);

    document.title = "Client View";
    window.addEventListener('resize', (e) => reportWindowSize(e));
    window.addEventListener("beforeunload", pageRefConf);
    window.addEventListener("popstate", pageRefConf);
    var url = new URL(window.location.href);
    var url_with_token = window.location.href;
    var board_id = url.searchParams.get("id").split("/")[0];
    var boardId = Buffer.from(board_id || "", "base64").toString("utf-8");
    setBoardId(boardId);
    setUserToken(url_with_token);
    var alreadyLoggedIn = localStorage.getItem("supabase.auth.token")
    alreadyLoggedIn && setShowLogin(false);
      
    var token = url.searchParams.get("id").split("/")[1];
    // For email based clients
    if (token) {
      setTokenWithouturl(token);
      var alreadyLoggedIn = localStorage.getItem("supabase.auth.token");
      if(alreadyLoggedIn) {
        setToLogin(true);
      }
      else{
        var details = JSON.parse(sessionStorage.getItem("publicInfo")) || "";
        details && setSessionDetails(details);
      }

      setJustView(false);
      setIsPublic(false);
      localStorage.setItem("clientUrl", url_with_token);
      checkClientForTrack(boardId,url_with_token);
      dispatch(getClient(boardId,url_with_token));
    } 

    else {
      mixpanel.track('client_view',{"email" : "Joined with Public link"});
      setShowLogin(false);
      localStorage.setItem("publicClientUrl", url_with_token);
      let details = JSON.parse(sessionStorage.getItem("publicInfo")) || "";
      details && setSessionDetails(details);
      dispatch(getPublicClient(boardId));
      }

      return () => {
        window.removeEventListener("beforeunload", pageRefConf);
        window.removeEventListener("popstate", pageRefConf);
      };
    }, []);

  useEffect(async() => {
    if(Object.keys(client).length > 0){
        setClient(client);
        setClientInvitationId(client.id);
        setClientEmail(client.email);
        localStorage.setItem("boardName", client.board.name);
        localStorage.setItem("clientId", client.id);
        await getBoardProfiles(client);
        await checkEmailAlreadySignedup(client.email);
        dispatch(getClientNotification(client.id));
    }

  },[client])

  useEffect(async() => {
    if(Object.keys(publicClient).length > 0){
        setClient(publicClient);
        localStorage.setItem("boardName", publicClient.board.name);
        getBoardProfiles(publicClient);
    }

  },[publicClient])

  useEffect(async() => {
    if(detailed_client_Profiles.length > 0){
      var all_profiles = [];
        Object.keys(currentClient).length > 0 && currentClient?.profiles?.forEach( (val,index) => {
          detailed_client_Profiles.forEach((profile, i) => {
            if(val.id == profile.id){
            var profile = { ...detailed_client_Profiles[i],paymentFrequency: val.paymentFrequency, client_hourly_rate: val.rate ,status: val.status, meetingTime: val.meetingTime, cancelUrl: val.cancel_url ? val.cancel_url : '', rescheduleUrl: val.reschedule_url ? val.reschedule_url : '', event_uuid: val.event_uuid ? val.event_uuid : '' };
            all_profiles.push(profile);
            }
            if(profile.id === sessionDetails[0]?.profileId){
              setScheduledProfile({ ...detailed_client_Profiles[i],paymentFrequency: val.paymentFrequency, client_hourly_rate: val.rate ,status: val.status, meetingTime: val.meetingTime, cancelUrl: val.cancel_url ? val.cancel_url : '', rescheduleUrl: val.reschedule_url ? val.reschedule_url : '', event_uuid: val.event_uuid ? val.event_uuid : '' });
            }
          })
        })
      
       setAllProfiles(all_profiles)
      } 
  },[detailed_client_Profiles])
  
  useEffect(() => {
    setTimeout(() => {
      setApplyTransition(false);
      setHideProfile(false);
    }, 401);
  }, [applyTransition]);

  useEffect(() => {
    if (dateTime.length >= 3) {
      setDateButton(true);
    } else {
      setDateButton(false);
    }
  }, [dateTime]);

  useEffect(async () => {
    if (boardId && tokenWithouturl) {
      localStorage.setItem("clientUrl", userToken);
      setShowLoader(true);
      setProfiles([]);
      let sessionInfo = JSON.parse(sessionStorage.getItem("publicInfo")) || "";
      setSessionDetails(sessionInfo);
      await getBoardProfiles(currentClient);
    }
  }, [showLogin]);

  useEffect(async () => {
    if (boardId && userToken && !justView) {
      const { data, error } = await supabase
      .from("board_clients_invitation")
        .select("*")
        .match({ board: boardId, url_with_token: userToken });

      setClientProfiles(data[0].profiles);
    }
  }, [statusValue]);

  useEffect ( async() => {
    var profile_id = localStorage.getItem("clientBoardProfile") || '';
    var screenSize = window.screen.width;
    if(screenSize >= 780) {
      if(profile_id){
        const index = profiles.findIndex((id) => {
          return id.id == profile_id
        });
        setShowProfileDetail(true);
        if(index < profiles.length-1){
          if(profiles[index]?.meetingTime) {
            await setProfile(profiles[index + 1]);
          } else {
            await setProfile(profiles[index]);
          }
        }
        else {
          if(profiles[index]?.meetingTime) {
            await setProfile(profiles[0]);
          } else {
            await setProfile(profiles[index]);
          }
        }
      }
    }
                    
  }, [profiles])

  useEffect( async() => {
    if(client_Profiles?.profiles?.length > 0){
      setClientProfiles(client_Profiles.profiles);
      setClient(client_Profiles);
      await getBoardProfiles(client_Profiles);
    }
    
  }, [client_Profiles])

  const checkClientForTrack = async(id, token) => {
    const { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ board: id, url_with_token: token });
    
    if(data && data.length){
      mixpanel.track('client_view',{"email" : data[0].email});
    }
  };

  const checkEmailAlreadySignedup = async(checkEmail) => {
    const {data , error} = await supabase
    .from("users")
    .select("*")
    .match({ email : checkEmail})
    if(data && data.length > 0){
      setToLogin(true);
    }
  }

  const getBoardProfiles = async (currentClient) => {

    if(Object.keys(currentClient).length > 0 && currentClient?.profiles.length > 0){
      let allIds = [];
      currentClient?.profiles.forEach( (p) => {
        allIds.push(p.id);
      })
      dispatch(getClientProfilesDetails(allIds));
    }
  };

  const setAllProfiles = async (profiles) => {
    profiles.map(async (profile) =>{
      for(let index = 0; index < currentClient?.profiles?.length; index++){
        
        // For logged in email user/ priavte user 
        if(profile.id == currentClient.profiles[index].id && userToken && sessionDetails.length <= 0){             
          if(currentClient?.profiles[index].meetingTime){
            // Start meeting time
            let date  = new Date(currentClient.profiles[index].meetingTime);
            profile.meetingTime = moment(date).format('MMM D, h:mm A') ;

            profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss') ;

            // End meeting time
            let endDate  = currentClient.profiles[index].endMeetingTime && new Date(currentClient.profiles[index].endMeetingTime);
            profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
          }
          else{
            profile.meetingTime = currentClient.profiles[index].meetingTime;
            profile.endMeetingTime = currentClient.profiles[index].endMeetingTime;
          }
        }
        // For not logged in email user/ priavte user
        else if(userToken && sessionDetails.length > 0){
          if(profile.id == sessionDetails[index]?.profileId){
            if(sessionDetails[index].startMeetingTime){
              // Start meeting time
              let date  = new Date(sessionDetails[index].startMeetingTime);
              profile.meetingTime = moment(date).format('MMM D, h:mm A') ;

              profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss') ;

              // End meeting time
              let endDate  = sessionDetails[index].endMeetingTime && new Date(sessionDetails[index].endMeetingTime);
              profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
              break;
            }
            else{
              profile.meetingTime = sessionDetails[index].startMeetingTime;
              profile.endMeetingTime = sessionDetails[index].endMeetingTime;
            }
          }
          else{
            profile.meetingTime = "";
            profile.endMeetingTime = "";
          }
          
        }
        // For public view
        else if(sessionDetails.length > 0 && profile.id == sessionDetails[index]?.profileId){

          if(sessionDetails[index].startMeetingTime){
            // Start meeting time
            let date  = new Date(sessionDetails[index].startMeetingTime);
            profile.meetingTime = moment(date).format('MMM D, h:mm A') ;

            // End meeting time
            let endDate  = sessionDetails[index].endMeetingTime && new Date(sessionDetails[index].endMeetingTime);
            profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
          }
          else{
            profile.meetingTime = sessionDetails[index].startMeetingTime;
            profile.endMeetingTime = sessionDetails[index].endMeetingTime;
          }

        }

        // Client hourly rate
        if(profile.id == currentClient.profiles[index].id){
            profile.client_hourly_rate = currentClient.profiles[index].rate;
            profile.paymentFrequency = currentClient.profiles[index].paymentFrequency;
        }
      }
    })

    setProfiles(profiles);
    setShowLoader(false);
  };

  const updateProfileStatus = async () => {
    setshowModal(false);
    setshowNewModal(false);
    setShowLoader(true);
    var all_profiles = [...clientProfiles];
    all_profiles = all_profiles.map((p) =>
      p.id == profileId
        ? { ...p, message: message, status: statusValue, meetingTime: dateTime }
        : p
    );

    const { data, error } = await supabase
      .from("board_clients_invitation")
      .update({ profiles: all_profiles })
      .match({ board: boardId, url_with_token: userToken });

    if (error) {
      setDisplayMessage("Sorry, unable to update status");
    } else {
      setDisplayMessage("Status Updated successfully.");
    }

    var all_profiles = [...profiles];
    all_profiles = all_profiles.map((p) =>
      p.id === profileId ? { ...p, status: statusValue } : p
    );
    // Set profiles
    setProfiles(all_profiles);

    setShowNotification(true);
    setMessage("");
    setProfileId("");
    setValue("New");
    setShowLoader(false);
    setDateTime([]);
    setDateTimePicker("");

    // Hide notification
    setTimeout(function () {
      setShowNotification(false);
    }, 2000);
  };

  const getProfileDetails = (id) => {
    var singleProfile = profiles.filter((index) => index.id == id);
    var screenSize = window.screen.width;
    if(screenSize >= 780) {
      if(profile == singleProfile[0]){
        setHideProfile(true);
        setTimeout( function () {
          setShowProfileDetail(!showProfileDetail);
          setProfile();
        }, 100);
      } else{
        setProfile(singleProfile[0]);
        setShowProfileDetail(true);
      }
      setApplyTransition(!applyTransition);
    }
    else {
      setShowProfileDetail(true);
      setMiniScreenProfileDetail(true);
      setProfile(singleProfile[0]);
    }
  };

  const handleCloseMiniProfileDetails = () => {
    setShowProfileDetail(false);
    setMiniScreenProfileDetail(false);
    setProfile();
  }

  const requestForInterview = (profileId,profileName) => {
    mixpanel.track('interviewRequest', {
      'profileName': profileName,
    });

    var url = new URL(window.location.href);
    var token = url.searchParams.get("id").split("/")[1];
    var alreadyLoggedIn = localStorage.getItem("supabase.auth.token") || '';
    if (token) {
      localStorage.setItem("clientBoardProfile", profileId);

      if(!alreadyLoggedIn) {
        setOpenModal(true);
      } else {
          localStorage.setItem("clientBoardProfile", profileId);
          let scheduled_profiles = 0;
          for(let profile = 0; profile<profiles.length; profile++){
            if(profiles[profile].meetingTime !=="" ){
              var date = new Date();
              var d =  moment(date).format('ddd MMM D YYYY HH:mm:ss');
              var res = moment(profiles[profile].fullMeetingTime).isSameOrBefore(d)
              if(!res){
                scheduled_profiles +=1;
                break;
              }
            }
          }
          if(scheduled_profiles > 0){
            navigate(`/addMeeting?client=${Buffer.from(clientInvitationId, "utf-8").toString("base64")}`);
          } else {
            navigate(`/interviewSchedule?client=${Buffer.from(clientInvitationId, "utf-8").toString("base64")}`);
          }
      }
     
    }
    else {
      if(sessionDetails.length > 0) {
        setOpenModal(true);
      } else {
        localStorage.setItem("clientBoardProfile", profileId);
        navigate(`/interviewSchedule?board=${Buffer.from(boardId, "utf-8").toString("base64")}`)
      }
    }
    setRequestInterview(true);
  };

 const handleClickStartInterview = () => {
    if(!showLoader){
      setProfile(profiles[0]);
      setShowProfileDetail(true);
      setApplyTransition(!applyTransition);
    }
  }

  const loadNextProfile = () => {
    const nextProfile = profiles.findIndex((id) => {
      return id.id == profile?.id
    });
    if(nextProfile<profiles.length-1){
    setProfile(profiles[nextProfile+1]);
    }
    else {
      setProfile(profiles[0]);
    }
    window.scrollTo(0, 0);
    executeScroll();
  }

  const toDashboard = () => {
    let link = client?.dashboard_id ;
    link && navigate(`/clientBoard?dashboard=${Buffer.from(link, "utf-8").toString("base64")}`);
  }

  return (
    <div className="w-full min-h-screen h-auto">
      <Header boardName={client?.board?.name || publicClient?.board?.name} showLoader={showLoader} loading={(value) => setLoading(value)} isLogin={!toLogin} isSignUp={() => setToLogin(!toLogin)} modal={openModal} justView={justView} showLogin={showLogin} onLogOut={() => {setLoading(true); setShowLogin(true);setToLogin(false);setMiniScreenProfileDetail(false);setShowProfileDetail(false);setLoading(false)}} handleOpenModal={handleOpenModal} clientInvitationId={clientInvitationId}>
        {/* Login Modal */}
        {!openModal && <Popover id="ZFWaEFxX" buttonColor="#379CFB" autoClose={500}/>}

        <Modal
          open={openModal}
          disableAutoFocus={true}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{style: {backgroundColor: '#F8FDFFB2'}}}
        >
          <>
            <Header justView={justView} modal={openModal} clientInvitationId={clientInvitationId} handleOpenModal={handleOpenModal} isLogin={toLogin} isSignUp={() => setToLogin(!toLogin)}> </Header>
            <Box sx={style}>
              {!toLogin && <h1 className={`text-[26px] xl-2:text-[32px] leading-snug text-center font-bold ${(sessionDetails.length > 0 && !tokenWithouturl) && 'mt-10'}`}>To maintain your engineer status, setup a password</h1>}
              {
                sessionDetails.length > 0 && !tokenWithouturl ? 
                <PublicLogin showLoader={(value) => setLoading(value)} showLogin={() => setShowLogin(false)} handleCloseModal={handleCloseModal} justView={() => setJustView(false)} profileId={profile?.id} profile={scheduledProfile} isPublic={isPublic} boardId={boardId} reqestInterview={reqestInterview} isLogin={toLogin} isSignUp={(value) => setToLogin(value)}/>
                :
                <Login sessionDetails={sessionDetails} showLogin={() => setShowLogin(false)} handleCloseModal={handleCloseModal} justView={() => setJustView(false)} clientEmail={clientEmail} profileId={profile?.id} isPublic={isPublic} boardId={boardId} clientInvitationId={clientInvitationId} reqestInterview={reqestInterview} isLogin={toLogin} isSignUp={() => setToLogin(false)}/>
              }
            </Box>
          </>
        </Modal>

        {loading && (
				<div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
				{/* Add backdrop */}
				
          <div className={`relative flex`}>
              <Oval
                color="white"
                secondaryColor="grey"
                height="40"
                width="60"
              />
            <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
				</div>
			)}

        {/* Notification */}
        <Snackbar
          open={showNotification}
          message={displayMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />

        {/* Add div */}
        <div className="bg-[#F1F2F5] grid grid-cols-12 gap-0 min-h-screen h-auto">
          {/* Show profiles */}
          <div className="col-span-12 md:col-span-6 md:sticky top-0 md:overflow-y-scroll scrollbar md:h-screen">
            <div className="col-span-12 md:px-6 px-4 pb-10">
            
              {showLoader ? <div className="mt-9"> 
                {/* <Skeleton height={30} width={150} className="ml-5" /> */}
                {
                  [...Array(3)].map((e , index) => (
                  <div className="-z-10 rounded bg-white-1 shadow-clientCard h-30 md:h-50 grid grid-cols-12 gap-3 p-4 box-border mt-4" key={index}>
                    <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex mt-5 relative">
                      <Skeleton height={90} width={90} />
                    </div>
                    <div  className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3 pl-5">
                      {/*For name and email */}
                      <div className="col-span-12">
                        <Skeleton height={23} width={150} />
                      </div>
                      {/* For location */}
                      <div className="col-span-6 lg:col-span-5">
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For timezone */}
                      <div className="col-span-6 lg:col-span-4">
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For experience */}
                      <div className="col-span-6 lg:col-span-5">
                        {/* experience label */}
                        <div className=" flex items-center">
                          <Skeleton height={18} width={92} className="mr-1" />
                        </div>
                        {/* experience */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                      {/* For hourly rate */}
                      <div className="col-span-6 lg:col-span-4">
                        {/* hourlyRate label */}
                        <div className="flex items-center">
                          <Skeleton height={18} width={92} className="mr-1" />
                        </div>
                        {/* hourly rate */}
                        <div className="flex items-center">
                          <Skeleton height={23} width={92} className="mr-1" />
                        </div>
                      </div>
                    </div>
                    <div className="hidden md:block col-span-2"></div>
                    {/* For Skills */}
                    <div className="col-span-12 md:col-span-10 ml-5">
                        <Skeleton height={30} width={200} />
                    </div>
                  </div>
                  ))
                  } </div> :
              profiles.length > 0 &&
              <div>
                <div className={`justify-items-start w-11/12 ${miniScreenProfieDetail && "mt-5"} grid md:hidden ml-1`}>
                    {miniScreenProfieDetail && <span className="cursor-pointer" onClick={handleCloseMiniProfileDetails}>Back To Board</span>}
                </div>

                {/* Breadcrums */}
               { tokenWithouturl &&
                 <div className="mt-6 text-[18px] ml-1 font-semibold justify-items-start w-11/12"><span className="font-normal cursor-pointer" onClick={() => toDashboard()} >Boards &gt; </span> {client?.board?.name|| publicClient?.board?.name}</div>}

                <div className="md:mt-5">
                  {profiles.map((data, index) => (
                      <div key={index} className={`${miniScreenProfieDetail ? 'hidden' : 'col-span-12'} md:col-span-3 pt-4`}>
                    
                        <Profile
                          profile={data}
                          currentProfile={profile}
                          getId = { (id) => getProfileDetails(id)}
                          updateProfileStatus={updateProfileStatus}
                          showNewModal={() => {
                            setshowNewModal(true);
                          }}
                          showModal={() => {
                            setshowModal(true);
                          }}
                          setProfileid={(e) => setProfileId(e)}
                          setValue={(e) => setValue(e)}
                          publicSessionDetails= {sessionDetails}
                          token={tokenWithouturl}
                          // justView={isPublic}
                          />
                      </div>
                  ))}
                </div>

              </div>
            }
            </div>
          </div>

          {/* Show text */}
          {!showProfileDetail ? (
            <div className="hidden md:block md:col-span-6 bg-blue-7 h-screen -mt-10 sticky top-0">
              <div className="flex flex-col items-center justify-center h-full">
                <div className="text-lg font-normal">
                  Software engineers
                  <div className="text-5xl font-bold mt-2">
                    Hire your
                    <br />
                    engineers in the
                    <br /> <span className="text-blue-4">next 24 hours.</span>
                  </div>
                  <span className={`text-pink-1 text-lg flex mt-2 ${!showLoader ? 'cursor-pointer' : ''}`} onClick={handleClickStartInterview} >
                    Start reviewing profiles{" "}
                    <svg
                      className="ml-3 mt-0.5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"
                        fill="rgba(255,73,116,1)"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          ) : (!miniScreenProfieDetail ?
             profile?.full_name?.length && 
              <ProfileDetails applyTransition={applyTransition} hideProfile={hideProfile} loading={showLoader} showLogin={showLogin} profile={profile} loadNextProfile={loadNextProfile} myRef={myRef} requestForInterview={requestForInterview} />
             :
            profile?.full_name?.length && 
              <MiniProfileDetails applyTransition={applyTransition} hideProfile={hideProfile} loading={showLoader} showLogin={showLogin} profile={profile} loadNextProfile={loadNextProfile} myRef={myRef} requestForInterview={requestForInterview} />
          )}
        </div>
      </Header>
    </div>
  );
}
export default Client;
